import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { getDefaultNetworkStatus } from '@utils';

import {
	targetsFetchCurrentReducer,
	targetsFetchItemReducer,
	targetsFetchListReducer,
} from './actions';

import { ITargetsStore } from './types';

export const getTargetsInitialState = (): ITargetsStore => ({
	targets: {
		data: {
			list: [],
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
	target: {
		data: {
			target: null,
			plan: null,
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
	currentTarget: {
		data: {
			target: null,
			plan: null,
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
});

export const targets = reducerWithInitialState<ITargetsStore>(getTargetsInitialState());

targetsFetchCurrentReducer(targets);
targetsFetchItemReducer(targets);
targetsFetchListReducer(targets);
